import React from 'react';
import {GoogleLogin, GoogleLogout} from 'react-google-login';
import {connect} from "react-redux";
import * as actionCreators from "../../actions/actionCreators"
import moment from "moment";
import 'moment/locale/fr';
moment.locale('fr');

class GoogleLoginButton extends React.Component {

    constructor(props) {
        super(props);

        this.responseGoogle = this.responseGoogle.bind(this);
        this.logoutGoogle = this.logoutGoogle.bind(this);
    }

    responseGoogle(response){
        if (this.props.user && response && 'code' in response && response.code) {
            this.props.updateUserAction(this.props.user.id, {
                google_refresh_token: response.code,
                google_access_token_expire_at: null,
            })
        }
    }

    logoutGoogle(){
        this.props.updateUserAction(this.props.user.id, {
            google_refresh_token: null,
            google_access_token_expire_at: null,
        })
    }

    render() {
        const expire_at = this.props.user.google_access_token_expire_at;
        return (
            <div>
                {(!expire_at) ? (
                    <GoogleLogin
                        clientId="627963324650-1i7920v6po1k7iil30qfd78ffgup0g7e.apps.googleusercontent.com"
                        buttonText="Associer mon compte Google"
                        accessType={"offline"}
                        prompt={"consent"}
                        scope="https://www.googleapis.com/auth/calendar"
                        responseType={"code"}
                        onSuccess={this.responseGoogle}
                        onFailure={this.responseGoogle}
                    />
                ) : (
                    <GoogleLogout
                        buttonText="Déconnecter le compte"
                        onLogoutSuccess={this.logoutGoogle}
                    >
                    </GoogleLogout>
                )}
            </div>
        );
    }
}
const mapStateToProps=(state)=>{
    return state
};

export default connect (mapStateToProps, actionCreators)(GoogleLoginButton);



// WEBPACK FOOTER //
// ./src/component/utils/GoogleLogin.js